import * as remoteAction from "../remoteAction";

export type GetShareActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_SHARE_SUCCESS",
  any
>;
export type GetShareActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_SHARE_FAILURE",
  any
>;
export type GetShareActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_SHARE_REQUEST",
  any
>;

export interface GetShareAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "GET_SHARE_REQUEST";
    success: "GET_SHARE_SUCCESS";
    failure: "GET_SHARE_FAILURE";
  };
}

export interface GetShareParams {
  merchantId: string;
  campaignId: string;
  widgetConfigId: string;
  message: string;
  email: string;
  channel: string;
  sendReminderEmail?: boolean;
  productId?: string;
  productName?: string;
  sku?: string;
  productVariantId?: string;
  [props: string]: string | boolean | undefined;
}

export const getShare = ({
  merchantId,
  campaignId,
  widgetConfigId,
  email,
  message,
  channel = "email",
  sendReminderEmail,
  productId,
  productName,
  sku,
  productVariantId,
  ...other
}: GetShareParams): GetShareAction => {
  return {
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      request: "GET_SHARE_REQUEST",
      failure: "GET_SHARE_FAILURE",
      success: "GET_SHARE_SUCCESS",
    },
    method: "POST",
    https: true,
    data: {
      merchantId,
      campaignId,
      widgetConfigId,
      email,
      channel,
      message: message || "",
      sendReminderEmail: sendReminderEmail ? "yes" : "no",
      ...other,
      ...(productId && { productId }),
      ...(productName && { productName }),
      ...(sku && { sku }),
      ...(productVariantId && { productVariantId }),
    },
    url: `/share`,
  };
};
